import { createSlice } from "@reduxjs/toolkit"

type OvationNotification = {
  showing: boolean
  ovation: Metricate.Ovation | []
}

const initialState: OvationNotification = {
  showing: false,
  ovation: [],
}

const OvationModalSlice = createSlice({
  name: "ovationmodal",
  initialState,
  reducers: {
    showOvationNotification: (state, action) => {
      state.showing = true
      state.ovation = action.payload
    },
    dismiss: (state) => {
      state.showing = false
      state.ovation = []
    },
  },
})

export const { showOvationNotification, dismiss } = OvationModalSlice.actions
export default OvationModalSlice.reducer
